<template>
  <global-dialog-card
    v-model="model"
    :title="editedItem.id ? `Измјена пословнице` : 'Нова пословница'"
    :subtitle="editedItem.id ? `ID: ${editedItem.id}` : ''"
  >
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12">
          <v-switch
            v-model="editedItem.state"
            inset
            :label="$t('active')"
            :false-value="0"
            :true-value="1"
            dense
          />
        </v-col>

        <v-col cols="12">
          <text-field
            v-model="editedItem.name"
            :rules="[rules.required]"
            :label="$t('title')"
            required
          />
        </v-col>

        <v-col cols="12">
          <autocomplete
            v-model="editedItem.type"
            :items="menuTypes"
            disabled
            item-text="name"
            item-value="name"
            :label="$t('available_menu_type_for_comp')"
            required
            :rules="[rules.required]"
          />
        </v-col>

        <v-col cols="12">
          <text-field hide-details v-model="editedItem.city" :label="$t('city')" />
        </v-col>
        <v-col cols="12">
          <text-field
            hide-details
            v-model="editedItem.address"
            :label="$t('address')"
          ></text-field>
        </v-col>
        <v-col cols="12">
          <text-field
            hide-details
            v-model="editedItem.phone"
            kind="phone"
            :label="$t('phone_no')"
          />
        </v-col>
        <v-col cols="12">
          <text-field hide-details v-model="editedItem.email" :label="$t('email')" />
        </v-col>
        <v-col cols="12">
          <text-field hide-details v-model="editedItem.lib" :label="$t('jib')" />
        </v-col>
        <v-col cols="12">
          <text-field hide-details v-model="editedItem.pib" :label="$t('pib')" />
        </v-col>
        <v-col cols="12">
          <text-area
            hide-details
            v-model="editedItem.description"
            :label="$t('description')"
          />
        </v-col>
        <v-col cols="12">
          <v-row align="start" no-gutters>
            <b>{{ $t("shit_one") }}</b>
            <v-radio-group
              v-model="editedItem.shift_one"
              row
              disabled
              style="margin-top: 1px; margin-left: 30px"
            >
              <v-radio :label="$t('yes')" :value="1" />
              <v-radio :label="$t('closed')" :value="0" />
            </v-radio-group>
          </v-row>
          <v-row align="start" no-gutters>
            <b>{{ $t("shit_two") }}</b>
            <v-radio-group
              v-model="editedItem.shift_two"
              row
              disabled
              style="margin-top: 1px; margin-left: 30px"
            >
              <v-radio :label="$t('yes')" :value="2" />
              <v-radio :label="$t('closed')" :value="0" />
            </v-radio-group>
          </v-row>
          <v-row align="start" no-gutters>
            <b>{{ $t("shit_three") }}</b>
            <v-radio-group
              v-model="editedItem.shift_three"
              row
              disabled
              style="margin-top: 1px; margin-left: 30px"
            >
              <v-radio :label="$t('yes')" :value="3" />
              <v-radio :label="$t('closed')" :value="0" />
            </v-radio-group>
          </v-row>
          <v-row align="start" no-gutters>
            <b>{{ $t("shit_four") }}</b>
            <v-radio-group
              v-model="editedItem.shift_four"
              row
              disabled
              style="margin-top: 1px; margin-left: 30px"
            >
              <v-radio :label="$t('yes')" :value="4" />
              <v-radio :label="$t('closed')" :value="0" />
            </v-radio-group>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <template #actions>
      <v-btn text @click="model = false">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button @click="save" :disabled="!valid" :dark="valid">
        {{ $t("save") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import companyService from "@/services/company";
import menuService from "@/services/menu";

export default {
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    menuTypes: [],
  }),
  created() {
    this.getMenuTypes();
  },
  methods: {
    async getMenuTypes() {
      try {
        const res = await menuService.getMenuTypes();
        this.menuTypes = res.data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_menu_types"));
      }
    },
    async save() {
      this.editedItem.parent_id =
        this.editedItem.id != this.$store.state.company.id
          ? this.$store.state.company.id
          : 0;
      try {
        if (this.editedItem.id) {
          await companyService.updateCompany(this.editedItem.id, this.editedItem);
          this.showSuccessSnackbar(this.$t("branch_updated"));
          this.$emit("updated", this.editedItem);
        } else {
          const res = await companyService.createCompany(this.editedItem);
          this.editedItem.id = res.data.id;
          this.showSuccessSnackbar(this.$t("branch_created"));
          this.$emit("created", this.editedItem);
        }
        this.dialog = false;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_saving_branch"));
      }
    },
  },
};
</script>
